// actions to get slides from the database
import axios from "axios";
import { API_URL } from "../variables";

export const FETCH_SLIDES_REQUEST = "FETCH_SLIDES_REQUEST";
export const FETCH_SLIDES_SUCCESS = "FETCH_SLIDES_SUCCESS";
export const FETCH_SLIDES_FAILURE = "FETCH_SLIDES_FAILURE";

export const fetchSlides = () => async (dispatch) => {
  dispatch({ type: FETCH_SLIDES_REQUEST });
  try {
    const response = await axios.get(`${API_URL}/api/users/slides/get-active`);
    dispatch({ type: FETCH_SLIDES_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_SLIDES_FAILURE, payload: error.message });
  }
};
